import * as yup from "yup";
const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
const dateRegex = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const model = {
  supplierName: "Tripjack",
  affiliateName: "",
  service: 1,
  tripType: "1",
  bookingId: "",
  userMarkup: 0,
  adminMarkup: 0,
  adults: 1,
  child: 0,
  infant: 0,
  airlinesMarkup: 0,
  airlinesMarkupCom: "Negative",
  airlinesMarkupReturn: 0,
  airlinesMarkupComReturn: "Negative",
  flightType: "Domestic",
  bookingReferenceNumber: "",
  gstAmount: 0,
  tdsAmount: 0,
  retGstAmount: 0,
  retTdsAmount: 0,
  flightLegs: {
    onward: [
      {
        airline: "",
        supplier: "",
        pnr: "",
        airportDepartureId: "",
        airportDestinationId: "",
        arrivalDate: "",
        departureDate: "",
        arrivalTime: "",
        departureTime: "",
        fN: "",
        airportDepartureTerminal: "",
        airportDestinationTerminal: "",
        // ticketNo: "",
        gdsPnr: "",
      },
    ],
    return: [
      {
        airline: "",
        supplier: "",
        pnr: "",
        airportDepartureId: "",
        airportDestinationId: "",
        arrivalDate: "",
        departureDate: "",
        arrivalTime: "",
        departureTime: "",
        fN: "",
        // ticketNo: "",
        gdsPnr: "",
        airportDepartureTerminal: "",
        airportDestinationTerminal: "",
      },
    ],
  },
  onwardAdultBF: "0",
  onwardAdultNF: "0",
  onwardAdultTF: "0",
  onwardAdultTAF: "0",
  onwardAdultPercentage: "0",
  onwardAdultTds: "0",
  onwardAdultDiscount: "0",
  onwardAdultDiscountWithGst: "0",
  onwardAdultGSTAmt: "0",

  onwardChildBF: "0",
  onwardChildNF: "0",
  onwardChildTF: "0",
  onwardChildTAF: "0",
  onwardChildPercentage: "0",
  onwardChildTds: "0",
  onwardChildDiscount: "0",
  onwardChildDiscountWithGst: "0",
  onwardChildGSTAmt: "0",

  onwardInfantBF: "0",
  onwardInfantNF: "0",
  onwardInfantTF: "0",
  onwardInfantTAF: "0",
  onwardInfantPercentage: "0",
  onwardInfantTds: "0",
  onwardInfantDiscount: "0",
  onwardInfantDiscountWithGst: "0",
  onwardInfantGSTAmt: "0",
  /////////////
  returnAdultBF: "0",
  returnAdultNF: "0",
  returnAdultTF: "0",
  returnAdultTAF: "0",
  returnAdultPercentage: "0",
  returnAdultTds: "0",
  returnAdultDiscount: "0",
  returnAdultDiscountWithGst: "0",
  returnAdultGSTAmt: "0",

  returnChildBF: "0",
  returnChildNF: "0",
  returnChildTF: "0",
  returnChildTAF: "0",
  returnChildPercentage: "0",
  returnChildTds: "0",
  returnChildDiscount: "0",
  returnChildDiscountWithGst: "0",
  returnChildGSTAmt: "0",

  returnInfantBF: "0",
  returnInfantNF: "0",
  returnInfantTF: "0",
  returnInfantTAF: "0",
  returnInfantPercentage: "0",
  returnInfantTds: "0",
  returnInfantDiscount: "0",
  returnInfantDiscountWithGst: "0",
  returnInfantGSTAmt: "0",

  pax: {
    onward: [
      {
        pt: "ADULT",
        ti: "Mr",
        fN: "",
        lN: "",
        food: [],
        fast: [],
        extraBag: [],
        seat: [],
        Wheelchair: false,
        refundable: 1,
        checkingBag: "",
        cabinBag: "",
        cc: "ECONOMY",
        pNat: "India",
        dob: "",
        pNum: "",
        eD: "",
        pid: "",
        ticketNo: "",
        ff: "",
      },
    ],
    return: [
      {
        pt: "ADULT",
        ti: "Mr",
        fN: "",
        lN: "",
        ticketNo: "",
        food: [],
        fast: [],
        extraBag: [],
        seat: [],
        refundable: 1,
        Wheelchair: false,
        checkingBag: "",
        cabinBag: "",
        cc: "ECONOMY",
        pNat: "India",
        dob: "",
        pNum: "",
        eD: "",
        pid: "",
        ff: "",
      },
    ],
  },
  gstMandatory: false,
  gstInfo: {
    gstNumber: "",
    email: "",
    registeredName: "",
    mobile: "",
    address: "",
  },
  ssrAmount: 0,
  returnSSRAmount: 0,
};

const validationSchema = yup.object().shape({
  supplierName: yup.string().required("Please Enter Supplier Name"),
  affiliateName: yup.string().required("Please Select Affiliate Name"),
  service: yup.string().required(),
  bookingId: yup.string().optional(),
  bookingReferenceNumber: yup.string().optional(),
  // bookingId: yup
  //   .string()
  //   .required("Booking Id Number is a required")
  //   .matches(
  //     /^[A-Za-z0-9]+$/,
  //     "Booking Id Number should not contain special characters"
  //   ),
  // bookingReferenceNumber: yup
  //   .string()
  //   .required("Booking Reference Number is a required")
  //   .matches(
  //     /^[A-Za-z0-9]+$/,
  //     "Booking Reference Number should not contain special characters"
  //   ),

  tripType: yup
    .string()
    .required("Please Select Journey Type")
    .notOneOf([""], "Please Select Journey Type"),
  flightType: yup
    .string()
    .required("Please Select Flight Type")
    .notOneOf([""], "Please Select Flight Type"),
  userMarkup: yup
    .number()
    .typeError("User Markup must be a number")
    .required("Please Enter User Markup")
    .min(0, "User Markup cannot be less than 0"),

  adminMarkup: yup
    .number()
    .typeError("Admin Markup must be a number")
    .required("Please Enter Admin Markup")
    .min(0, "Admin Markup cannot be less than 0"),
  adults: yup
    .number()
    .typeError("Adults must be a number")
    .min(1, "At least 1 adult required")
    .required("Adults is required"),

  child: yup
    .number()
    .typeError("Child must be a number")
    .min(0, "Child cannot be less than 0")
    .optional(),

  infant: yup
    .number()
    .typeError("Infant must be a number")
    .min(0, "Infant cannot be less than 0")
    .optional(),
  airlinesMarkup: yup.string().optional(),
  airlinesMarkupCom: yup.string().optional(),

  gstAmount: yup.string().optional(),
  tdsAmount: yup.string().optional(),
  retGstAmount: yup.string().optional(),
  retTdsAmount: yup.string().optional(),

  airlinesMarkupReturn: yup.string().optional(),
  airlinesMarkupComReturn: yup.string().optional(),

  flightLegs: yup.object().shape({
    onward: yup.array().of(
      yup.object().shape({
        // refundable: yup.number().required("Please Enter Refundable Or Not"),
        supplier: yup.string().optional(),
        airline: yup.string().required("Please Enter Airline"),
        // ticketNo: yup.string().optional(),
        gdsPnr: yup
          .string()
          .optional()
          .matches(
            /^[A-Za-z0-9]+$/,
            "PNR must be alphanumeric (no special characters)",
          ),
        pnr: yup
          .string()
          .required("Please Enter PNR")
          .matches(
            /^[A-Za-z0-9]+$/,
            "PNR must be alphanumeric (no special characters)",
          ),
        arrivalTime: yup.string().required("Please Enter Arrival Time"),
        arrivalDate: yup
          .string()
          .required("Please Enter Arrival Date")
          .matches(dateRegex, "Invalid date (DD-MM-YYYY, year 1900–2099)"),

        departureDate: yup
          .string()
          .required("Please Enter Departure Date")
          .matches(dateRegex, "Invalid date (DD-MM-YYYY, year 1900–2099)"),
        departureTime: yup.string().required("Please Enter departure Time"),
        airportDepartureId: yup
          .string()
          .required("Please Enter Airport Departure"),
        airportDestinationId: yup
          .string()
          .required("Please Enter Airport Destination"),
        fN: yup
          .string()
          .required("Please Enter Flight Number")
          .matches(/^\d+$/, "Flight Number must be numeric"),
      }),
    ),
    return: yup.array().when("$tripType", {
      is: (value) => value != 1,
      then: yup.array().of(
        yup
          .object()
          .shape({
            // refundable: yup.number().required("Please Enter Refundable Or Not"),
            supplier: yup.string().optional(),
            airline: yup.string().required("Please Enter Airline"),
            // ticketNo: yup.string().optional(),
            gdsPnr: yup
              .string()
              .optional()
              .matches(
                /^[A-Za-z0-9]+$/,
                "PNR must be alphanumeric (no special characters)",
              ),
            pnr: yup
              .string()
              .required("Please Enter PNR")
              .matches(
                /^[A-Za-z0-9]+$/,
                "PNR must be alphanumeric (no special characters)",
              ),
            arrivalTime: yup.string().required("Please Enter Arrival Time"),
            arrivalDate: yup
              .string()
              .required("Please Enter Arrival Date")
              .matches(dateRegex, "Invalid date (DD-MM-YYYY, year 1900–2099)"),

            departureDate: yup
              .string()
              .required("Please Enter Departure Date")
              .matches(dateRegex, "Invalid date (DD-MM-YYYY, year 1900–2099)"),
            departureTime: yup.string().required("Please Enter departure Time"),
            airportDepartureId: yup
              .string()
              .required("Please Enter Airport Departure"),
            airportDestinationId: yup
              .string()
              .required("Please Enter Airport Destination"),
            fN: yup
              .string()
              .required("Please Enter Flight Number")
              .matches(/^\d+$/, "Flight Number must be numeric"),
          })
          .required(),
      ),
    }),

    // .optional(),
  }),

  // pax details

  pax: yup.object().shape({
    onward: yup.array().of(
      yup.object().shape({
        pt: yup
          .string()
          .required("Please Select Pax Type")
          .notOneOf([""], "Please Select Pax Type"),
        ti: yup
          .string()
          .required("Please Select Pax Title")
          .notOneOf([""], "Please Select Pax Title"),

        fN: yup
          .string()
          .trim()
          .matches(nameRegex, "Only alphabets allowed")
          .required("Please Enter First Name"),

        lN: yup
          .string()
          .trim()
          .matches(nameRegex, "Only alphabets allowed")
          .required("Please Enter Last Name"),
        // dob: yup.string().when("$flightType", {
        //   is: "International",
        //   then: (s) => s.required("Date of Birth is required"),
        // }),

        // pNum: yup.string().when("$flightType", {
        //   is: "International",
        //   then: (s) => s.required("Passport Number is required"),
        // }),

        // eD: yup.string().when("$flightType", {
        //   is: "International",
        //   then: (s) => s.required("Expiry Date is required"),
        // }),

        // pid: yup.string().when("$flightType", {
        //   is: "International",
        //   then: (s) => s.required("Passport Issue Date is required"),
        // }),
        food: yup.array().of(yup.object()).optional(),
        fast: yup.array().of(yup.object()).optional(),
        extraBag: yup.array().of(yup.object()).optional(),
        seat: yup.array().of(yup.object()).optional(),
        // BF: yup.string().optional(),
        // NF: yup.string().optional(),
        // TF: yup.string().optional(),
        // TAF: yup.string().optional(),
        ticketNo: yup.string().optional(),
        cc: yup
          .string()
          .required("Please Select Cabin Class")
          .notOneOf([""], "Please Select Cabin Class"),
        refundable: yup.number().required("Please Enter Refundable Or Not"),
      }),
    ),

    // .optional(),
    return: yup.array().when("$tripType", {
      is: (value) => value != "1",
      then: yup.array().of(
        yup.object().shape({
          pt: yup
            .string()
            .required("Please Select Pax Type")
            .notOneOf([""], "Please Select Pax Type"),
          ti: yup
            .string()
            .required("Please Select Pax Title")
            .notOneOf([""], "Please Select Pax Title"),

          fN: yup
            .string()
            .trim()
            .matches(nameRegex, "Only alphabets allowed")
            .required("Please Enter First Name"),

          lN: yup
            .string()
            .trim()
            .matches(nameRegex, "Only alphabets allowed")
            .required("Please Enter Last Name"),
          // dob: yup.string().when("$flightType", {
          //   is: "International",
          //   then: (s) => s.required("Date of Birth is required"),
          // }),

          // pNum: yup.string().when("$flightType", {
          //   is: "International",
          //   then: (s) => s.required("Passport Number is required"),
          // }),

          // eD: yup.string().when("$flightType", {
          //   is: "International",
          //   then: (s) => s.required("Expiry Date is required"),
          // }),

          // pid: yup.string().when("$flightType", {
          //   is: "International",
          //   then: (s) => s.required("Passport Issue Date is required"),
          // }),
          food: yup.array().of(yup.object()).optional(),
          fast: yup.array().of(yup.object()).optional(),
          extraBag: yup.array().of(yup.object()).optional(),
          seat: yup.array().of(yup.object()).optional(),
          // BF: yup.string().optional(),
          // NF: yup.string().optional(),
          // TF: yup.string().optional(),
          // TAF: yup.string().optional(),
          ticketNo: yup.string().optional(),
          cc: yup
            .string()
            .required("Please Select Cabin Class")
            .notOneOf([""], "Please Select Cabin Class"),
          refundable: yup.number().required("Please Enter Refundable Or Not"),
        }),
      ),
    }),

    // .optional(),
  }),

  ///onward
  onwardAdultBF: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),
  onwardAdultTAF: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),
  onwardAdultTF: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),
  onwardAdultNF: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),
  onwardAdultPercentage: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),

  // onwardAdultTds: yup.number().when("adults", {
  //   is: (adults) => adults > 0,
  //   then: yup.number().optional(),
  // }),
  // onwardAdultDiscount: yup.number().when("adults", {
  //   is: (adults) => adults > 0,
  //   then: yup.number().optional(),
  // }),
  ////////////////////
  onwardChildBF: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  onwardChildTAF: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  onwardChildTF: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  onwardChildNF: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  onwardChildPercentage: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  // onwardChildTds: yup.number().when("child", {
  //   is: (child) => child > 0,
  //   then: yup.number().optional(),
  // }),
  // onwardChildDiscount: yup.number().when("child", {
  //   is: (child) => child > 0,
  //   then: yup.number().optional(),
  // }),

  ////
  onwardInfantBF: yup.number().when("infant", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),
  onwardInfantTAF: yup.number().when("infant", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),
  onwardInfantTF: yup.number().when("infant", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),
  onwardInfantNF: yup.number().when("infant", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),
  onwardInfantPercentage: yup.number().when("child", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),

  ////return

  // Conditional validation for return fare fields based on tripType
  returnAdultBF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("adults", {
      is: (adults) => adults > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnAdultTAF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("adults", {
      is: (adults) => adults > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnAdultTF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("adults", {
      is: (adults) => adults > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnAdultNF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("adults", {
      is: (adults) => adults > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnChildBF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("child", {
      is: (child) => child > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnChildTAF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("child", {
      is: (child) => child > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnChildTF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("child", {
      is: (child) => child > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnChildNF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("child", {
      is: (child) => child > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnInfantBF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("infant", {
      is: (infant) => infant > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnInfantTAF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("infant", {
      is: (infant) => infant > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnInfantTF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("infant", {
      is: (infant) => infant > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnInfantNF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("infant", {
      is: (infant) => infant > 0,
      then: yup.number().required("Required"),
    }),
  }),
  gstMandatory: yup.boolean().optional(),
  gstInfo: yup.object().shape({
    gstNumber: yup.string().when("gstMandatory", {
      is: true,
      then: yup.string().required("GST Number is required"),
    }),
    email: yup
      .string()
      .email("Invalid email!")
      .when("gstMandatory", {
        is: true,
        then: yup.string().required("Email Id is required"),
      }),
    registeredName: yup.string().when("gstMandatory", {
      is: true,
      then: yup.string().required("GST Name date is required"),
    }),
    mobile: yup.string().when("gstMandatory", {
      is: true,
      then: yup.string().required("Mobile Number is required"),
    }),
    address: yup.string().when("gstMandatory", {
      is: true,
      then: yup.string().required("GST Address is required"),
    }),
  }),
  ssrAmount: yup.number().required("Required"),
  returnSSRAmount: yup.number().required("Required"),
});

export { model, validationSchema };
